import * as Types from '../../../../../generated/graphql.types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateCourseAssetIdMutationVariables = Types.Exact<{
  id: Types.Scalars['String'];
  assetId: Types.Scalars['Int'];
}>;


export type UpdateCourseAssetIdMutation = { __typename?: 'MutationRoot', updateCourseAssetId: { __typename?: 'Course', id: string } };

export type UpdateSpotAssetIdMutationVariables = Types.Exact<{
  id: Types.Scalars['String'];
  assetId: Types.Scalars['Int'];
}>;


export type UpdateSpotAssetIdMutation = { __typename?: 'MutationRoot', updateSpotAssetId: { __typename?: 'Spot', id: string } };

export type GetCourseAssetIdQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetCourseAssetIdQuery = { __typename?: 'QueryRoot', course: { __typename?: 'Course', assetId: number } };

export type GetSpotAssetIdQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetSpotAssetIdQuery = { __typename?: 'QueryRoot', spot: { __typename?: 'Spot', assetId: number } };


export const UpdateCourseAssetIdDocument = gql`
    mutation UpdateCourseAssetId($id: String!, $assetId: Int!) {
  updateCourseAssetId(input: {id: $id, assetId: $assetId}) {
    id
  }
}
    `;

export function useUpdateCourseAssetIdMutation() {
  return Urql.useMutation<UpdateCourseAssetIdMutation, UpdateCourseAssetIdMutationVariables>(UpdateCourseAssetIdDocument);
};
export const UpdateSpotAssetIdDocument = gql`
    mutation UpdateSpotAssetId($id: String!, $assetId: Int!) {
  updateSpotAssetId(input: {id: $id, assetId: $assetId}) {
    id
  }
}
    `;

export function useUpdateSpotAssetIdMutation() {
  return Urql.useMutation<UpdateSpotAssetIdMutation, UpdateSpotAssetIdMutationVariables>(UpdateSpotAssetIdDocument);
};
export const GetCourseAssetIdDocument = gql`
    query GetCourseAssetId($id: String!) {
  course(id: $id) {
    assetId
  }
}
    `;

export function useGetCourseAssetIdQuery(options: Omit<Urql.UseQueryArgs<GetCourseAssetIdQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCourseAssetIdQuery, GetCourseAssetIdQueryVariables>({ query: GetCourseAssetIdDocument, ...options });
};
export const GetSpotAssetIdDocument = gql`
    query GetSpotAssetId($id: String!) {
  spot(id: $id) {
    assetId
  }
}
    `;

export function useGetSpotAssetIdQuery(options: Omit<Urql.UseQueryArgs<GetSpotAssetIdQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSpotAssetIdQuery, GetSpotAssetIdQueryVariables>({ query: GetSpotAssetIdDocument, ...options });
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateCourseAssetIdMutation((req, res, ctx) => {
 *   const { id, assetId } = req.variables;
 *   return res(
 *     ctx.data({ updateCourseAssetId })
 *   )
 * })
 */
export const mockUpdateCourseAssetIdMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateCourseAssetIdMutationVariables>, GraphQLContext<UpdateCourseAssetIdMutation>, any>) =>
  graphql.mutation<UpdateCourseAssetIdMutation, UpdateCourseAssetIdMutationVariables>(
    'UpdateCourseAssetId',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateSpotAssetIdMutation((req, res, ctx) => {
 *   const { id, assetId } = req.variables;
 *   return res(
 *     ctx.data({ updateSpotAssetId })
 *   )
 * })
 */
export const mockUpdateSpotAssetIdMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateSpotAssetIdMutationVariables>, GraphQLContext<UpdateSpotAssetIdMutation>, any>) =>
  graphql.mutation<UpdateSpotAssetIdMutation, UpdateSpotAssetIdMutationVariables>(
    'UpdateSpotAssetId',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetCourseAssetIdQuery((req, res, ctx) => {
 *   const { id } = req.variables;
 *   return res(
 *     ctx.data({ course })
 *   )
 * })
 */
export const mockGetCourseAssetIdQuery = (resolver: ResponseResolver<GraphQLRequest<GetCourseAssetIdQueryVariables>, GraphQLContext<GetCourseAssetIdQuery>, any>) =>
  graphql.query<GetCourseAssetIdQuery, GetCourseAssetIdQueryVariables>(
    'GetCourseAssetId',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetSpotAssetIdQuery((req, res, ctx) => {
 *   const { id } = req.variables;
 *   return res(
 *     ctx.data({ spot })
 *   )
 * })
 */
export const mockGetSpotAssetIdQuery = (resolver: ResponseResolver<GraphQLRequest<GetSpotAssetIdQueryVariables>, GraphQLContext<GetSpotAssetIdQuery>, any>) =>
  graphql.query<GetSpotAssetIdQuery, GetSpotAssetIdQueryVariables>(
    'GetSpotAssetId',
    resolver
  )
